<script setup>
import { ref } from 'vue'
import { Plus } from '@element-plus/icons-vue'
import {userTokenStore} from "@/store/store.js";
import {genFileId} from "element-plus";
import {useSnowflakeHook} from "@/hooks/snowflake.js";
import {getSignatureUrl} from "@/api/upload/upload.js";
const { generateId } = useSnowflakeHook();
import axios from 'axios';

const props = defineProps({
  // 文件最大上传数量
  limit: {
    type: Number,
    default: 5
  },
  // 图片宽度
  width: {
    type: Number,
    default: 900
  },
  // 图片高度
  height: {
    type: Number,
    default: 400
  },
  // 图片大小：MB
  fileSize: {
    type: Number,
    default: 1
  },
  // 文件格式
  fileType: {
    type: Array,
    default: () => ['jpg', 'jpeg', 'png']
  },
  // 提示出现位置，默认情况下是document.body，可以参考ElementPlus的Message组件文档
  tipsAppendTo: {
    type: String,
    default: "document.body"
  },
  // 外部索引，主要用于成功事件携带外部索引值，提供同个页面多个上传组件的索引值给外部赋值使用
  index: {
    type: Number,
    default: null
  },
  // 是否显示必填
  isRequired: {
    type: Boolean,
    default: false
  },
  // 提示语
  tips: {
    type: String,
    default: "请上传图片。"
  },
  // 是否logo模式
  isLogoMode: {
    type: Boolean,
    default: false
  },
  isReplaceMode: {
    type: Boolean,
    default: false
  },
  // 阿里oss预上传地址枚举
  aliOssPath: {
    required: true,
    type: String,
  },
  // 虚拟头像字样
  title: {
    type: String,
    default: "LOGO"
  }
})
// 事件
const emit = defineEmits(['success', 'change', 'remove', 'progress'])

/*文件上传请求配置*/
// 请求基地址
const baseUrl = import.meta.env.VITE_API_URL + "/upload/uploadImg"
// token
const token = userTokenStore().token
// 请求头携带信息
const headers = {
  Authorization: token.tokenValue,
  "Login-Type": token.loginType
}
// 请求体携带信息
const data = {
  path: props.prePath,
  // 1临时文件 2永久文件
  uploadDownloadType: 2,
}

/*组件功能定义*/
// 是否有新上传文件（反显时配合提交功能使用）
const isChange = ref(false)
// 用于展示的文件列表
const fileList = ref([])
// 用于对话框展示的大图地址
const dialogImageUrl = ref('')
// 展示对话框开启状态
const dialogVisible = ref(false)
// 组件锚点
const fileUpload = ref()
// 展示大图
const handleOnPreview = (file) => {
  console.log("run in handleOnPreview file", file)
  dialogImageUrl.value = file.url
  dialogVisible.value = true
}
// 删除展示的文件
const handleOnRemove = (file) => {
  console.log("过滤之前", successUrl.value)
  successUrl.value = []
  fileList.value = fileList.value.filter(item => {
    if (item.uid !== file.uid) successUrl.value.push(item.url)
    return item.uid !== file.uid
  })
  console.log("移除了文件", successUrl.value)
  emit('remove', successUrl.value, props.index)
  successLimit.value--
}
// 文件上传成功
const handleOnSuccess = (file) => {
  try {
    console.log("file.data", file.data[0])
    successUrl.value.push(file.data[0])
    successLimit.value++
    if (props.isRequired) {
      if (successLimit.value !== fileList.value.length) {
        console.log("上传成功数组与组件缓存图片张数不符，清空上传成功数组重新赋值")
        successUrl.value = []
        successLimit.value = 0
        successUrl.value.push(file.data[0])
        successLimit.value++
      }
      emit('success', successUrl.value, props.index)
    } else {
      emit('success', successUrl.value, props.index)
    }
  } catch (e) {
    console.log(e)
    ElMessage({
      message: file.msg ? file.msg : "未知错误",
      type: "error",
      appendTo: props.tipsAppendTo
    })
  }
}
// 文件上传失败
const handleOnError = () => {
  console.log("run in handleOnError")
  ElMessage({
    message: "上传失败，请重试",
    type: "error",
    appendTo: props.tipsAppendTo
  })
}
// 文件上传中
const handleProgress = () => {
  console.log("run in handleProgress")
  emit('progress')
}
// 选择了上传文件，但未请求上传接口
const handleOnChange = async (file) => {
  console.log("run in change")
  console.log(file)
  const input = fileUpload.value?.$el?.querySelector('input[type="file"]')
  const files = input?.files
  if (files.length > 5) {
    ElMessage.error("单次上传最多选择5张图片！")

    fileList.value = fileList.value.filter(f => f.status === "success" && !f.url.startsWith("blob:"))
    successUrl.value = successUrl.value.filter(url => !url.startsWith("blob:"))
    successLimit.value = successUrl.value.length
    return
  }
  isChange.value = true
  const isPassFormat = await checkFileFormat(file)
  if (!isPassFormat) return
  const res = await uploadFile(file)
  if (res.code === 0) {
    let param = {
      ...res.fileInfo,
      data: res.fileUrl
    }
    handleOnSuccess(param)
  } else {
    ElMessage.error("文件上传失败")
  }
  // emit('change', fileList.value.length)
}
// 文件上传格式、大小错误
const handleOnExceed = (files) => {
  console.log("run in handleOnExceed")
  if (props.isReplaceMode) {
    console.log("run in if props.isReplaceMode", files)
    fileUpload.value.clearFiles();
    const file = files[0];
    file.uid = genFileId();
    fileUpload.value.handleStart(file);
    console.log("file", file);
    // fileUpload.value.submit();
    // handleOnChange()
  } else {
    ElMessage({
      message: `上传文件数量不能超过 ${props.limit} 个!`,
      type: "error",
      appendTo: props.tipsAppendTo
    })
  }
}
// 校验文件类型和文件大小
const checkFileFormat = async (file) => {
  // 校检文件类型
  if (props.fileType) {
    const fileName = file.name.split('.');
    const fileExt = fileName[fileName.length - 1];
    const isTypeOk = props.fileType.indexOf(fileExt) >= 0;
    if (!isTypeOk) {
      ElMessage({
        message: `文件格式不正确, 请上传${props.fileType.join("/")}格式文件!`,
        type: "error",
        appendTo: props.tipsAppendTo
      });
      const index = fileList.value.indexOf(file.uid);
      fileList.value.splice(index,1)
      return false;
    }
  }
  // 校检文件大小
  if (props.fileSize) {
    const isLt = file.size / 1024 / 1024 < props.fileSize;
    if (!isLt) {
      ElMessage({
        message: `上传文件大小不能超过 ${props.fileSize} MB!`,
        type: "error",
        appendTo: props.tipsAppendTo
      });
      const index = fileList.value.indexOf(file.uid);
      fileList.value.splice(index,1)
      return false;
    }
  }
  return true;
}
// 文件上传
const handleUpload = () => {
  fileUpload.value.submit()
}

/*反显功能*/
// 成功上传的文件数量（反显时配合提交功能使用）
const successLimit = ref(0)
// 成功上传的文件地址（反显时配合提交功能使用）
const successUrl = ref([])
// 反显图片
const handleReview = (reviewList) => {
  console.log("handleReview", reviewList)
  fileList.value = []
  successUrl.value = []
  reviewList.forEach(item => {
    fileList.value.push({url: item})
    successUrl.value.push(item)
  })
  console.log("handleReview fileList.value", fileList.value)
  console.log("handleReview successUrl.value", successUrl.value)
  successLimit.value = fileList.value.length
}
// 清空上传图片信息
const handleClearList = () => {
  fileList.value = []
  successUrl.value = []
  successLimit.value = 0
}

// 使用预上传地址上传文件
const uploadFile = async (file) => {
  const urlParam = await getFileUploadUrl(file)
  if (urlParam.code === -1) return ElMessage.error("上传失败")
  const urlObj = new URL(urlParam.signedUrl);
  const fileUrl = urlObj.origin + urlObj.pathname;

  try {
    const response = await axios.put(urlParam.signedUrl, file.raw, {
      headers: { 'Content-Type': 'application/octet-stream' }
    });

    if (response.status === 200) {
      return { code: 0, fileUrl: [fileUrl], fileInfo: file };
    } else {
      return { code: -1, fileUrl: null };
    }

  } catch (err) {
    console.error(err);
    return { code: -1, fileUrl: null };
  }
}
// 获取文件预上传地址
const getFileUploadUrl = async (file) => {
  try {
    const id = generateId()
    const rawFile = file.raw
    // 获取文件后缀
    const ext = rawFile.name.includes('.') ? rawFile.name.substring(rawFile.name.lastIndexOf('.')) : '.bin';
    let param = {
      uploadDownloadTypeEnum: "PERMANENT",
      aliOssImgUploadPathEnum: props.aliOssPath,
      fileName: props.aliOssPath + id + ext
    }
    const res = await getSignatureUrl(param)
    console.log("res", res)
    return {code: 0, signedUrl: res}
  } catch (e) {
    console.log(e)
    return {code: -1, signedUrl: null}
  }
}

// 暴露给外部使用的变量以及函数
defineExpose({
  handleUpload,
  handleReview,
  fileList,
  successUrl,
  isChange,
  handleClearList
})
</script>

<template>
  <div class="flex">
    <div style="margin-right: 43px;">
      <div class="avatar_box flex_center" v-if="fileList.length === 0">
        <div v-if="props.isLogoMode">
          {{props.title}}
        </div>
        <img v-else src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/default_avatar.svg" />
      </div>
      <img v-else class="avatar_box" :src="successUrl[0]" />
    </div>
    <el-upload
        style="text-align: left"
        v-model:file-list="fileList"
        :action="baseUrl"
        :multiple="false"
        :on-preview="handleOnPreview"
        :on-remove="handleOnRemove"
        :on-success="handleOnSuccess"
        :on-error="handleOnError"
        :on-progress="handleProgress"
        :on-exceed="handleOnExceed"
        :before-upload="checkFileFormat"
        :show-file-list="false"
        :on-change="handleOnChange"
        list-type="text"
        :limit="props.limit"
        :headers="headers"
        :data="data"
        ref="fileUpload"
        :auto-upload="false">
      <div>
        <div class="flex_align_t">
          <div>
            <span style="color: #DC4C2F;margin-right: 5px;font-size: 16px" v-if="props.isRequired">*</span>
          </div>
          <div>
            <div class="tips">
              <span>{{props.tips}}</span>
            </div>
            <div class="tips">
              建议尺寸{{props.width}} * {{props.height}}，最多{{props.limit}}张，单张图片不超过{{props.fileSize}}MB
            </div>
          </div>
        </div>
        <v-btn style="margin-left: 11px;" class="upload_btn" color="#D7D7DF">上传照片</v-btn>
      </div>
    </el-upload>
  </div>

  <el-dialog v-model="dialogVisible">
    <img width="100%" :src="dialogImageUrl" alt="Preview Image" />
  </el-dialog>
</template>

<style scoped>
.tips {
  font-weight: 500;
  color: #717172;
}
.upload_btn {
  font-weight: 500;
  font-size: 14px;
  color: #272539;
  box-sizing: border-box;
  padding: 0 32px;
  height: 37px;
}
.avatar_box {
  width: 123px;
  height: 123px;
  background: #F0F0F0;
  border-radius: 50%;
  font-weight: 500;
  font-size: 26px;
  color: #414141;
  line-height: 123px;
  text-align: center;
}
::v-deep(.el-upload-list) {
  display: none;
}
</style>

